import { Component, AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { StorageService } from '@core/services/util/storage.service';

@Component({
    selector: 'app-birthday-animation',
    templateUrl: './birthday-animation.component.html',
    styleUrls: ['./birthday-animation.component.scss'],
    standalone: true
})
export class BirthdayAnimationComponent implements AfterViewInit {

    birthdayAnimationConfig: any;
    liveCnt: number = 0;
    intervalTimer: any = null;
    // colors: Array<String> = ['a', 'b', 'c', 'f', 'g', 'h', 'i', 'j', 'k'];
    colors: Array<String> = ['#00a6d4', '#aad4ff', '#ceffff', '#ebe9f9', '#ff94cd', '#ff8e7a', '#ff910a', '#f1e867', '#b67aff'];
    isBirthday: boolean;

    base: string;

    constructor(
        private storageService: StorageService,
        private datePipe: DatePipe,
    ) {
        this.birthdayAnimationConfig = {
            balloon: {
                min_width: 200,
                max_width: 300
            },
            max_balloon_count: 30
        };
        if (this.storageService.get('birthday')) {
            this.isBirthday = this.storageService.get('birthday').slice(5) === this.datePipe.transform(new Date().getTime(), 'MM-dd');
        }
    }

    ngAfterViewInit() {
        this.initiate();
    }

    initiate() {
        const _this = this;
        if (this.isBirthday && !this.storageService.get('sbda')) {
            let today: any = new Date().setHours(23, 59, 59, 59);
            today = new Date(today);
            this.intervalTimer = setInterval(() => {
                if (_this.liveCnt < _this.birthdayAnimationConfig.max_balloon_count) {
                    setTimeout(() => {
                        _this.makeBalloon();
                    }, Math.random() * 1000);
                } else {
                    clearInterval(_this.intervalTimer);
                    _this.storageService.set('sbda', 'false', today);
                }
            },
                100
            );
        }
    }

    getRandomIntInclusive(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    buildElement(template) {
        const key = 'balloon_' + (new Date()).getTime();
        let item;

        if (!template.content) {
            const temp = document.createElement('div');
            temp.innerHTML = template.innerHTML;
            item = temp.cloneNode(true);
        } else {
            item = template.children[0]?.cloneNode(true);
        }

        document.querySelector('.image-container').setAttribute('id', key);
        const balloonDiv = document.querySelector('.balloon-div');
        balloonDiv.classList.add('balloon');
        const balloon = balloonDiv.querySelectorAll('.balloon-body');
        const b1 = balloon[0] as HTMLElement;
        const b2 = balloon[1] as HTMLElement;
        const selectColor = `${this.colors[Math.floor(Math.random() * this.colors.length)]}`;
        b1.style.fill = selectColor;
        b2.style.fill = selectColor;
        return item;
    }

    setDisplayParams(element) {
        const viewWidth = document.documentElement.clientWidth,
            viewHeight = document.getElementById('sky-content').clientHeight;

        const top = viewHeight - (10 * Math.random() * 1);
        const width = this.getRandomIntInclusive(this.birthdayAnimationConfig.balloon.min_width, this.birthdayAnimationConfig.balloon.max_width);
        const left = Math.random() * (viewWidth);
        const zIndex = parseInt(width, 1);

        let time = 0.8 * (1000 / width);
        time = time > 9 ? 8.6 : time;

        element.style.top = top + 'px';
        element.style.width = width + 'px';
        element.style.left = left + 'px';
        element.style.zIndex = zIndex;
        element.style.webkitAnimationDuration = time + 's';
        element.style.mozAnimationDuration = time + 's';
        element.style.animationDuration = time + 's';
    }

    makeBalloon() {
        if (this.liveCnt >= this.birthdayAnimationConfig.max_balloon_count) {
            return;
        }
        const template = document.getElementById('balloon-template'),
            balloon = this.buildElement(template),
            container = document.getElementById('sky-content'),
            id = document.querySelector('.image-container').getAttribute('id');

        this.liveCnt++;
        container.appendChild(document.importNode(balloon, true));
        const element = document.getElementById(id);
        this.setDisplayParams(element);
        element.classList.add('slideInUp');
        document.addEventListener('webkitAnimationEnd, mozAnimationEnd MSAnimationEnd oanimationend animationend', () => {
            element.remove();
            // this.storageService.set('sbda', null, new Date());
        });
    }
}
